import {
  GET_SHOWROOMS,
  GET_SHOWROOMS_SUCCESS,
  GET_SHOWROOMS_FAIL,
  GET_SHOWROOM_DETAILS,
  GET_SHOWROOM_DETAILS_SUCCESS,
  GET_SHOWROOM_DETAILS_FAIL,
  CREATE_SHOWROOM,
  CREATE_SHOWROOM_SUCCESS,
  CREATE_SHOWROOM_FAIL,
  UPDATE_SHOWROOM,
  UPDATE_SHOWROOM_SUCCESS,
  UPDATE_SHOWROOM_FAIL,
  DELETE_SHOWROOM_SUCCESS,
  DELETE_SHOWROOM_FAIL,
  DELETE_SHOWROOM,

} from "./actionTypes"

// Showroom - This line cannot be edited or removed
export const getShowrooms = (
  page,
  limit,
  searchText,
  showroomId,

) => ({
  type: GET_SHOWROOMS,
  payload: { page, limit, searchText, showroomId,  },
})

export const getShowroomsSuccess = showrooms => ({
  type: GET_SHOWROOMS_SUCCESS,
  payload: showrooms,
})

export const getShowroomsFail = error => ({
  type: GET_SHOWROOMS_FAIL,
  payload: error,
})

export const getShowroomDetails = showroomId => ({
  type: GET_SHOWROOM_DETAILS,
  payload: showroomId,
})

export const getShowroomDetailsSuccess = showroomDetails => ({
  type: GET_SHOWROOM_DETAILS_SUCCESS,
  payload: showroomDetails,
})

export const getShowroomDetailsFail = error => ({
  type: GET_SHOWROOM_DETAILS_FAIL,
  payload: error,
})

export const createShowroom = (showroom, onCloseClick) => ({
  type: CREATE_SHOWROOM,
  payload: { showroom, onCloseClick },
})

export const createShowroomSuccess = showroom => ({
  type: CREATE_SHOWROOM_SUCCESS,
  payload: showroom,
})

export const createShowroomFail = error => ({
  type: CREATE_SHOWROOM_FAIL,
  payload: error,
})

export const getShowroomDetail = showroomId => ({
  type: GET_SHOWROOM_DETAILS,
  payload: showroomId,
})

export const updateShowroom = (showroom, showroomId,onCloseClick) => ({
  type: UPDATE_SHOWROOM,
  payload: { showroom, showroomId ,onCloseClick},
})

export const updateShowroomSuccess = showroom => ({
  type: UPDATE_SHOWROOM_SUCCESS,
  payload: showroom,
})

export const updateShowroomFail = error => ({
  type: UPDATE_SHOWROOM_FAIL,
  payload: error,
})

export const deleteShowroom = showroomId => ({
  type: DELETE_SHOWROOM,
  payload: { showroomId },
})

export const deleteShowroomSuccess = showroom => ({
  type: DELETE_SHOWROOM_SUCCESS,
  payload: showroom,
})

export const deleteShowroomFail = error => ({
  type: DELETE_SHOWROOM_FAIL,
  payload: error,
})
